import { useState, useEffect } from 'react';
import Title from './title';
import Flds from './flds';
import Btn from './btn';
import Mess from './mess';
import Info from './info';
import './style.css';
import Login from 'skin/auth/login';
import { type } from 'skin/event';

const arr2 = [
	{
		tit: 'IP-адрес',
		val: '192.168.1.1',
	},
	{
		tit: 'Браузер',
		val: 'Информация о браузере',
	},
	{
		tit: 'Дата и время',
		val: new Date().toLocaleString(),
	},
];

const Win = (props) => {
	let cls = ['skin-win', 'window', 'login'];
	cls = cls.join(' ');
	const [mess, setMess] = useState([]);
	const [info, setInfo] = useState([]);
	useEffect(loadInfo, []);

	return (
		<div className={cls}>
			<Title title="Авторизация пользователя" />
				
			<form onSubmit={login}>
				<Flds />
				<div className='btn-login'>
				<Btn title="Регистрация" click={signup} type="button" />
				<Btn title="Сброс пароля" click={reset} type="button" />
				<Btn title="Войти"  type="submit"/>
				</div>
			</form>
			<Mess mess={mess} />
			<Info info={info} />
		</div>
	);
	// Запросить ситемную информацию
	function loadInfo() {
		document.getElementsByName('login')[0].focus();
		setInfo(arr2);
	}

	// Авторизация
	function login(e) {
		e.preventDefault();

		let login = document.getElementById('login').value;
		login = login.trim()
		let password = document.getElementById('password').value;
		password = password.trim()
		Login(login, password, setMess);
	}
	// Регистрация
	function signup() {
		type('signup');
	}

	// Сброс пароля
	function reset() {
		type('reset')
	}

};

export default Win;
